import { MinusIcon, PlusIcon } from '@/components/icons';
import { cx } from '@/utils/cx';
import { Button } from './Button';
import styles from '@/styles/components/Stepper/style.scss';

interface StepperProps {
  value: number;
  onChange: (next: number) => void;
  /** What is being counted, for screen readers ("Water"). */
  label: string;
  min?: number;
  max?: number;
}

/** − count + control. */
export function Stepper({ value, onChange, label, min = 0, max = 999 }: StepperProps) {
  return (
    <div className={styles.stepper} role="group" aria-label={`${label} quantity`}>
      <Button
        size="sm"
        iconOnly
        icon={<MinusIcon size={14} />}
        aria-label={`Remove one ${label}`}
        disabled={value <= min}
        onClick={() => onChange(Math.max(min, value - 1))}
        className={styles.step}
      />
      <span className={cx(styles.count, value > 0 && styles.nonZero)} aria-live="polite">
        {value}
      </span>
      <Button
        size="sm"
        iconOnly
        icon={<PlusIcon size={14} />}
        aria-label={`Add one ${label}`}
        disabled={value >= max}
        onClick={() => onChange(Math.min(max, value + 1))}
        className={styles.step}
      />
    </div>
  );
}
